import script from "./KeyDocumentStatusCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeyDocumentStatusCard.vue?vue&type=script&lang=ts&setup=true"

import "./KeyDocumentStatusCard.vue?vue&type=style&index=0&id=8aa54b48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aa54b48"]])

export default __exports__